import angular from 'angular'

import template from '../../../templates/error/offline-notice.html'
import { WEB_REGISTER } from '../../components/web-register.constant'

/**
 * Directive for a notice informing the user they're offline providing a link to the vend system status. For use in
 * offline related error pages or modals.
 *
 * @module webregister.directives.offlineNotice
 */
angular
  .module('webregister.directives')
  .directive('offlineNotice', function () {
    return {
      scope: {
        heading: '@',
      },
      restrict: 'E',
      template,
      bindToController: true,
      controllerAs: 'offlineNoticeCtrl',

      link(scope, $element) {
        $element.addClass('wr-offline-notice')
      },

      /**
       * =======================================
       * OFFLINE NOTICE CONTROLLER
       * =======================================
       */
      controller(this: $TSFixMe) {
        this.vendStatusUrl = WEB_REGISTER.VEND_STATUS_URL
      },
    }
  })
